import AXIOS from "@/axios";
import { APIResponse } from "@/types";
import {
  StudentListType,
  StudentModel,
  StudentQuery,
} from "@/types/student.model";
import { removeEmptyProps } from "@/utils/constants";
import moment from "moment";

interface CreateStudentResponse {
  id: string;
  login_user: string;
  login_email: string;
  token: string;
  is_email_sent: boolean;
}

interface UpdateStudentResponse {
  id: string;
  login_user: string;
  login_email: string;
}

export const getAllStudentService = async (query: StudentQuery) => {
  if (query.fromDate && query.toDate) {
    query.fromDate = moment(new Date(query.fromDate).toISOString()).format(
      "DD-MM-YYYY"
    );
    query.toDate = moment(new Date(query.toDate).toISOString()).format(
      "DD-MM-YYYY"
    );
  }

  return AXIOS.get<APIResponse<StudentModel[]>>("/stdnt/api/v1/list", {
    params: removeEmptyProps(query),
  });
};

export const getAllStudentV2Service = async (
  query: StudentQuery & { type: StudentListType }
) => {
  if (query.fromDate && query.toDate) {
    query.fromDate = moment(new Date(query.fromDate).toISOString()).format(
      "DD-MM-YYYY"
    );
    query.toDate = moment(new Date(query.toDate).toISOString()).format(
      "DD-MM-YYYY"
    );
  }

  const { type, gradeId, classId, ...rest } = query;

  // course → gradeId only; class → classId only (accept either field from callers).
  // all → whichever resource id was provided.
  const resourceParams =
    type === "class"
      ? { classId: classId || gradeId }
      : type === "course"
        ? { gradeId: gradeId || classId }
        : { gradeId, classId };

  return AXIOS.get<APIResponse<StudentModel[]>>("/stdnt/api/v2/list", {
    params: removeEmptyProps({ ...rest, type, ...resourceParams }),
  });
};

export const createStudentService = async (payload: StudentModel) => {
  return AXIOS.post<APIResponse<CreateStudentResponse>>(
    "/stdnt/api/v1/add",
    payload
  );
};

export const updateStudentService = async (
  id: string,
  payload: StudentModel
) => {
  return AXIOS.patch<APIResponse<UpdateStudentResponse>>(
    `/stdnt/api/v1/update/${id}`,
    payload
  );
};

export const deleteStudentService = async (id: string) => {
  return AXIOS.delete<{ message: string }>(`/stdnt/api/v1/delete/${id}`);
};

export const getStudentService = async (id: string) => {
  return AXIOS.get<APIResponse<StudentModel>>(`/stdnt/api/v1/view/${id}`);
};

export const downloadStudentService = async (
  type: "pdf" | "xl" | "csv",
  params: StudentQuery
) => {
  if (params.fromDate && params.toDate) {
    params.fromDate = moment(new Date(params.fromDate).toISOString()).format(
      "DD-MM-YYYY"
    );
    params.toDate = moment(new Date(params.toDate).toISOString()).format(
      "DD-MM-YYYY"
    );
  }

  return AXIOS.get<{ message: string }>(`/stdnt/api/v1/dwnld/${type}`, {
    params: removeEmptyProps(params),
    responseType: "blob",
  });
};
